var map = {
	".": 974,
	"./": 974,
	"./App": 772,
	"./App.css": 50,
	"./App.tsx": 772,
	"./Reason/Reason-1.jpeg": 120,
	"./Reason/Reason-10.JPG": 624,
	"./Reason/Reason-11.png": 22,
	"./Reason/Reason-12.png": 229,
	"./Reason/Reason-13.png": 548,
	"./Reason/Reason-14.JPG": 980,
	"./Reason/Reason-2.png": 708,
	"./Reason/Reason-3.jpeg": 346,
	"./Reason/Reason-4.jpeg": 51,
	"./Reason/Reason-5.png": 651,
	"./Reason/Reason-6.jpeg": 685,
	"./Reason/Reason-7.jpeg": 718,
	"./Reason/Reason-8.jpeg": 991,
	"./Reason/Reason-9.PNG": 494,
	"./index": 974,
	"./index.css": 555,
	"./index.tsx": 974,
	"./logo.svg": 445,
	"./react-app-env.d": 59,
	"./react-app-env.d.ts": 59,
	"./reportWebVitals": 469,
	"./reportWebVitals.ts": 469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;